export default "__VITE_ASSET__Dye_IUtu__"